import React from 'react';
import { StickyHeader } from '../components/StickyHeader';
import { HeroSection } from '../components/HeroSection';
import { PainPoints } from '../components/PainPoints';
import { SolutionSection } from '../components/SolutionSection';
import { ModulesSection } from '../components/ModulesSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { BonusesSection } from '../components/BonusesSection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  const handleFinalCTA = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Track the InitiateCheckout event
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'MegaPack Mecánica Preventiva',
        content_category: 'Digital Product',
        value: 19990,
        currency: 'ARS'
      });
    }
    // Smooth delay before redirect
    setTimeout(() => {
      window.location.href = 'https://checkout.recursospro.shop/cart/47636218675456:1';
    }, 300);
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-187">
      <StickyHeader data-id="element-188" />

      <main data-id="element-189">
        <HeroSection data-id="element-190" />
        <PainPoints data-id="element-191" />
        <SolutionSection data-id="element-192" />
        <ModulesSection data-id="element-193" />
        <ComparisonSection data-id="element-194" />
        <BonusesSection data-id="element-195" />
        <PricingSection data-id="element-196" />
        <TestimonialsSection data-id="element-197" />
        <FAQSection data-id="element-198" />

        {/* Final CTA Section */}
        <section className="bg-black text-white py-16 px-4 text-center" data-id="element-199">
          <div className="max-w-3xl mx-auto" data-id="element-200">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-201">
              Cuidar tu auto puede ser más simple
            </h2>
            <p className="text-xl text-gray-300 mb-8" data-id="element-202">
              No necesitás saberlo todo. Necesitás criterio, prevención y
              control.
            </p>
            <a href="https://checkout.recursospro.shop/cart/47636218675456:1" onClick={handleFinalCTA} className="inline-block bg-gradient-to-b from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-bold text-xl px-12 py-5 rounded-lg shadow-xl border-b-4 border-green-700 transition-all duration-300 transform active:scale-95 hover:scale-105 mb-8" data-id="element-203">
              👉 Accedé ahora al MegaPack
            </a>
            <p className="text-gray-400 font-medium" data-id="element-204">
              Porque no necesitás ser mecánico, solo saber lo suficiente para
              decidir bien. 🔧🚗
            </p>
          </div>
        </section>
      </main>

      <footer className="bg-gray-900 text-gray-600 py-8 text-center text-sm border-t border-gray-800" data-id="element-205">
        <div className="container mx-auto px-4" data-id="element-206">
          <p data-id="element-207">
            © {new Date().getFullYear()} MegaPack Mecánica Preventiva. Todos
            los derechos reservados.
          </p>
          <p className="mt-2" data-id="element-208">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-209" />
    </div>;
}